import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "image-background-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.75 12.4399C15.75 12.8542 15.4142 13.1899 15 13.1899H9C8.58579 13.1899 8.25 12.8542 8.25 12.4399C8.25 12.0257 8.58579 11.6899 9 11.6899L15 11.6899C15.4142 11.6899 15.75 12.0257 15.75 12.4399Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 5.18994C3.48122 5.18994 2.25 6.42116 2.25 7.93994V17.056C2.25 18.5748 3.48122 19.806 5 19.806H19.0039C20.5227 19.806 21.7539 18.5748 21.7539 17.056V7.93994C21.7539 6.42116 20.5227 5.18994 19.0039 5.18994H5ZM3.75 7.93994C3.75 7.24959 4.30964 6.68994 5 6.68994H19.0039C19.6943 6.68994 20.2539 7.24959 20.2539 7.93994V17.056C20.2539 17.7464 19.6943 18.306 19.0039 18.306H5C4.30964 18.306 3.75 17.7464 3.75 17.056V7.93994Z"
    }, null, -1)
  ])))
}
export default { render: render }